module.exports = __webpack_public_path__ + "img/op_about.728e1bd.jpg";